import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../assets/avatar.svg";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              SOME <span className="light-brown">THINGS</span> ABOUT ME
            </h1>
            <p className="home-about-body">
              I'm a 28 years old <b className="light-brown">programming lover</b> and Telematics Engineer,
              passionate about technology and about <b className="light-brown">learning</b> everything
              at everytime.️
              <br />
              <br />I'm mainly a back-end engineer who worked mainly with
                <b className="light-brown"> Javascript, Java and Python </b>
              <br />
              <br />
              Currently working with and loving &nbsp;
                <b className="light-brown">
                  Typescript and NodeJS
                </b>
              <br />
              <br />
              I'm kind obsessed with
                <b className="light-brown"> Frameworks, Automation Abstraction</b> and&nbsp;
                <b className="light-brown">Abstraction</b>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>WHERE AM I?</h1>
            <p>
              Feel free to <span className="light-brown">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/victorigualada"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-github"></i>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/víctorigualada"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
